import ScrollMagic from "scrollmagic";

import "./video-autoplay-onenter.scss";

const videoAutoplayOnEnter = () => {
    let controlleVideoAutoplayOnEnter = new ScrollMagic.Controller();
    let sectionVideoAutoplayOnEnter = document.querySelectorAll(
        ".video-autoplay-onenter"
    );

    if (!sectionVideoAutoplayOnEnter.length) return;

    sectionVideoAutoplayOnEnter.forEach((element) => {
        let videoToPlay = element.querySelector(".video-to-play");

        let sceneVideoAutoplayOnEnter = new ScrollMagic.Scene({
            triggerHook: "onEnter",
            triggerElement: element,
        })
            .on("start", function () {
                if (videoToPlay) {
                    videoToPlay.play();
                }
            })
            .addTo(controlleVideoAutoplayOnEnter);

        let playButton = element.querySelector(".video-control");
        if (!playButton) return;

        playButton.addEventListener("click", (evt) => {
            let dataModalVideo =
                evt.currentTarget.getAttribute("data-modal-video");
            let urlModalVideo = evt.currentTarget.getAttribute("data-full-uri");
            if (dataModalVideo) {
                let modalVideo = document.querySelector(
                    '.modal-video-autoplay-video[data-modal-video="' +
                        dataModalVideo +
                        '"]'
                );
                if (modalVideo) {
                    modalVideo.classList.add("open");
                    let videoInModal =
                        modalVideo.querySelector(".video-in-modal");
                    if (videoInModal) {
                        if (urlModalVideo) {
                            videoInModal.setAttribute("src", urlModalVideo);
                        }
                        videoInModal.play();
                    }
                }
            }
        });

        let buttonClose = document.querySelectorAll(
            ".modal-video-autoplay-video .button-close"
        );
        if (buttonClose.length) {
            buttonClose.forEach((element) => {
                element.addEventListener("click", () => {
                    let allModalOpened = document.querySelectorAll(
                        ".modal-video-autoplay-video"
                    );
                    allModalOpened.forEach((el) => {
                        if (el.classList.contains("open")) {
                            let videoToStop =
                                el.querySelector(".video-in-modal");
                            el.classList.remove("open");
                            if (videoToStop) {
                                videoToStop.pause();
                            }
                        }
                    });
                });
            });
        }

        const closeAllOnKeyup = (e) => {
            if (e.keyCode === 27) {
                let allModalOpened = document.querySelectorAll(
                    ".modal-video-autoplay-video"
                );
                allModalOpened.forEach((el) => {
                    if (el.classList.contains("open")) {
                        let videoToStop = el.querySelector(".video-in-modal");
                        el.classList.remove("open");
                        if (videoToStop) {
                            videoToStop.pause();
                        }
                    }
                });
            }
        };

        document.addEventListener("keyup", closeAllOnKeyup);
    });
};

export default videoAutoplayOnEnter;
